import { render, staticRenderFns } from "./HeraFormSwitchRevert.vue?vue&type=template&id=3cef468a&"
import script from "./HeraFormSwitchRevert.vue?vue&type=script&lang=js&"
export * from "./HeraFormSwitchRevert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports